/**
 * HowItWorks Section
 * Использует переиспользуемые компоненты
 */
import { Text, Icon, Container } from '../components';

export default function HowItWorksSection({ data, styles }) {
  const steps = data?.steps || [];
  const sectionStyle = data?.style || 'numbered';

  const getGridClasses = () => {
    const count = steps.length;
    if (count === 1) return 'grid-cols-1 max-w-md mx-auto';
    if (count === 2) return 'grid-cols-1 md:grid-cols-2 max-w-2xl mx-auto';
    if (count === 3) return 'grid-cols-1 md:grid-cols-3 max-w-4xl mx-auto';
    return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
  };

  const renderNumberedStyle = () => (
    <div className={`grid gap-6 md:gap-8 ${getGridClasses()}`}>
      {steps.map((step, index) => (
        <div key={step.id || index} className="text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center mx-auto mb-4 text-xl md:text-2xl font-bold">
            {index + 1}
          </div>
          <Text
            as="h3"
            data={typeof step.title === 'object' ? step.title : { text: step.title }}
            defaults={{ size: 'xl', weight: 'semibold', color: 'foreground' }}
            className="mb-2"
          />
          <Text
            as="p"
            data={typeof step.description === 'object' ? step.description : { text: step.description }}
            defaults={{ size: 'base', weight: 'normal', color: 'text-secondary' }}
            className="leading-relaxed"
          />
        </div>
      ))}
    </div>
  );

  const renderIconsStyle = () => (
    <div className={`grid gap-6 md:gap-8 ${getGridClasses()}`}>
      {steps.map((step, index) => (
        <div key={step.id || index} className="text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-4">
            <Icon name={step.icon || 'Star'} size="xl" />
          </div>
          <Text
            as="h3"
            data={typeof step.title === 'object' ? step.title : { text: step.title }}
            defaults={{ size: 'xl', weight: 'semibold', color: 'foreground' }}
            className="mb-2"
          />
          <Text
            as="p"
            data={typeof step.description === 'object' ? step.description : { text: step.description }}
            defaults={{ size: 'base', weight: 'normal', color: 'text-secondary' }}
            className="leading-relaxed"
          />
        </div>
      ))}
    </div>
  );

  const renderTimelineStyle = () => (
    <div className="relative">
      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 bg-border h-full" />

      <div className="space-y-8 md:space-y-12">
        {steps.map((step, index) => (
          <div
            key={step.id || index}
            className={`flex flex-col md:flex-row items-center gap-4 md:gap-8 ${
              index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
            }`}
          >
            <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} text-center md:text-inherit`}>
              <Text
                as="h3"
                data={typeof step.title === 'object' ? step.title : { text: step.title }}
                defaults={{ size: 'xl', weight: 'semibold', color: 'foreground' }}
                className="mb-2"
              />
              <Text
                as="p"
                data={typeof step.description === 'object' ? step.description : { text: step.description }}
                defaults={{ size: 'base', weight: 'normal', color: 'text-secondary' }}
                className="leading-relaxed"
              />
            </div>

            <div className="relative z-10 w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-lg md:text-xl font-bold shadow-lg flex-shrink-0">
              {index + 1}
            </div>

            <div className="hidden md:block flex-1" />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop || 64,
        paddingBottom: styles?.paddingBottom || 64,
        backgroundColor: styles?.backgroundColor || '#FFFFFF'
      }}
    >
      <Container>
        {/* Заголовок */}
        <Text
          as="h2"
          data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
          defaults={{ size: '3xl', weight: 'bold', color: 'foreground' }}
          align="center"
          className={data?.subtitle ? 'mb-2 md:mb-3' : 'mb-8 md:mb-12'}
        />

        {/* Подзаголовок */}
        <Text
          as="p"
          data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
          defaults={{ size: 'lg', weight: 'normal', color: 'text-secondary' }}
          align="center"
          className="mb-8 md:mb-12"
        />

        {steps.length > 0 ? (
          <>
            {sectionStyle === 'numbered' && renderNumberedStyle()}
            {sectionStyle === 'icons' && renderIconsStyle()}
            {sectionStyle === 'timeline' && renderTimelineStyle()}
          </>
        ) : (
          <div className="text-center py-12 text-text-secondary">
            <Icon name="ListOrdered" size="3xl" className="mx-auto mb-4 opacity-50" />
            <p>Добавьте шаги в настройках</p>
          </div>
        )}
      </Container>
    </section>
  );
}
